import type { HelpFile } from '../../types/help'
import { ExecutionLogViewerTestIds } from '../../../testids/ExecutionLogViewerTestIds'

export const executionLogViewerHelp: HelpFile = {
  docPage: '/docs/jobs/execution-logs',
  texts: {
    [ExecutionLogViewerTestIds.btnDownloadLogs]:
      'Download the full execution log as a text file — useful for offline investigation or sharing with colleagues.',
  },
}
